module.exports = __webpack_public_path__ + "img/gsndc2765_1.317b4ae9.svg";